var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:({background: _vm.$vuetify.theme.themes[_vm.theme].background})},[_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }